<template>

<router-link :to="{name: linkTo}" class="cell">

	<app-icon :name="icon" class="cell-icon" />

	<div class="cell-text">{{ text }}<small v-if="premium && showPremium">Premium members only</small></div>

	<div class="cell-count" v-if="count">{{ count }}</div>

</router-link>

</template>

<script>

export default {

	props: ['icon', 'text', 'to', 'count', 'premium'],

	computed: {

		linkTo: function() {

			return (this.premium && !this.session.business.premium) ? 'Account/Upgrade' : this.to

		},

		showPremium: function() {

			return this.session.business.trialling || !this.session.business.premium

		}

	}

}

</script>

<style scoped>

.cell {
	flex-grow: 1;
	flex-basis: 0;
	flex-shrink: 0;
	margin: 5px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 20px;
	border-radius: 4px;
	min-height: 150px;
	background-color: var(--color-blue-light);
	transition: all 100ms linear;
}

.is-mobile .cell {
    padding: 10px;
    height: 120px;
    min-width: 120px;
}

.is-desktop .cell:hover {
	background-color: var(--color-blue-dark);
    transform: scale(1.03);
}

.cell-icon {
	width: 64px;
	height: 64px;
	font-size: 48px;
	line-height: 64px;
	text-align: center;
    color: #fff;
}

.cell-text {
    color: #fff;
    font-family: "grueber",serif;
    font-size: 18px;
	text-align: center;
    line-height: 24px;
}

.cell-text small {
	display: block;
	font-size: 13px;
	line-height: 12px;
}

.is-mobile .cell-text {
    text-align: center;
}

.cell-count {
	position: absolute;
	font-weight: 700;
	color: #fff;
	right: 10px;
	top: 10px;
	font-size: 14px;
}

</style>